<template>
  <v-container fluid>
    <v-row justify="center" align="center" class="full">
      <v-col class="d-flex justify-center">
        <router-view></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SessionLayout"
};
</script>

<style scoped>
.session {
  min-height: 100vh;
}
</style>
